import React, { Component } from "react";
import PropTypes from "prop-types";
import Card from "./Card";

class ExpandableCard extends Component {
  static propTypes = {
    title: PropTypes.string.isRequired,
    leftComponent: PropTypes.func,
    rightComponent: PropTypes.func,
    onClick: PropTypes.func,
    onToggle: PropTypes.func,
    // onOpen: PropTypes.func,
    children: PropTypes.node,
    expanded: PropTypes.bool,
    disabled: PropTypes.bool
  };

  static defaultProps = {
    leftComponent: () => null,
    rightComponent: () => null,
    onToggle: () => null,
    onClick: null,
    children: null,
    // onOpen: () => null,
    expanded: false,
    disabled: false
  };

  constructor(props) {
    super(props);
    const { expanded } = this.props;
    this.state = {
      expanded
    };
  }

  toggleContent = () => {
    const { disabled, onToggle } = this.props;
    const { expanded } = this.state;
    if (!disabled) {
      this.setState(
        prevState => ({
          expanded: !prevState.expanded
        }),
        () => {
          onToggle(expanded);
        }
      );
    }
  };

  renderLeftComponent = expanded => {
    const { leftComponent } = this.props;

    if (leftComponent) {
      return leftComponent(expanded);
    }

    return null;
  };

  renderRightComponent = expanded => {
    const { rightComponent } = this.props;

    if (rightComponent) {
      return rightComponent(expanded);
    }

    return null;
  };

  render() {
    const { expanded } = this.state;
    const { title, description, onClick, children, openCard, optional } = this.props;

    return (
      <Card className="expandable-card">
        <div
          className="header"
          onClick={() => (onClick ? onClick() : this.toggleContent())}
        >
          <div className="left-component">
            {this.renderLeftComponent(expanded)}
          </div>
          <div className="center-component">
            <div className="title">{title}{optional}</div>
            <div className="description">{description}</div>
          </div>
          <div className="right-component">
            {this.renderRightComponent(expanded)}
          </div>
        </div>
        {(expanded || openCard) && <div className="content">{children}</div>}
      </Card>
    );
  }
}

export default ExpandableCard;



// WEBPACK FOOTER //
// ./src/components/ExpandableCard.js